<template>
    <div>
    </div>
</template>

<script>
    import firebase from 'firebase/compat/app';
    import 'firebase/auth';
    import fb from '../firebase/init';
    import { updateProfile } from "firebase/auth"

    export default {
        name: 'AuthUserFirebase',
        props: ['clientId', 'userId', 'hashedClientId','hashedUserId'],
        data() {
            return {}
        },
        methods: {
            authUserFirebase(email, password) {
                firebase.auth().signInWithEmailAndPassword(email, password).catch((error) => {
                    firebase.auth().createUserWithEmailAndPassword(email, password).catch((error) => {
                    }).then((result) => {
                        let user = firebase.auth().currentUser;
                      updateProfile( user, {displayName: clientId}).then(result => {
                            firebase.auth().signOut().then(() => {
                                firebase.auth().signInWithEmailAndPassword(email, password).then(result => {
                                })
                            });
                        });
                    });
                });
            },
            authAdminFirebase(email, password) {
              console.log(email);
                firebase.auth().signInWithEmailAndPassword(email, password).catch((error) => {
                    console.log(error);
                    firebase.auth().createUserWithEmailAndPassword(email, password).catch((error) => {
                        console.log(error);
                    }).then((result) => {
                        let user = firebase.auth().currentUser;
                        updateProfile( user, {displayName: "isAdmin"}).then(result => {
                            firebase.auth().signOut().then(() => {
                                firebase.auth().signInWithEmailAndPassword(email, password).then(result => {
                                })
                            });
                        });
                    });
                }).then((result) => {
                    console.log(result)
                });
            }
        },
        created() {
            const loginUser = this.clientId + '-' + this.userId + '-admin@hutter-unger.de';
            const loginAdmin = this.userId + '-admin@hutter-unger.de';
            const loginPassword = this.hashedClientId + this.hashedUserId;
            if (firebase.apps.length !== 0){
                firebase.auth().onAuthStateChanged((user) => {
                    if (!user) {
                        if (this.clientId) {
                            this.authUserFirebase(loginUser,loginPassword);
                        } else {
                            this.authAdminFirebase(loginAdmin,loginPassword);
                        }
                    }
                });
            }
        }
    }

</script>

<style>

</style>
